<template>
<v-container>
  <v-form v-model="isFormValid" ref="form">
    <v-row class="ma-0 pa-0">
      <v-col cols="3" class="ma-0 pb-0">
        <text-box-date-picker
          class="pa-0 ma-0"
          v-model="workingProduct.designStartDate"
          label="Design Start Date"
          :disabled="!isEditable || !isStartDateChangeable()"
          ref="designStartDate"/>
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0 red--text text-body-2" v-if="!isDesignDateValid.isValid">
      <v-col>
        <b>Error:</b> {{this.isDesignDateValid.message}}
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="6">
        <v-checkbox
          class="pa-0 ma-0"
          ref="activeCheckbox"
          v-model="workingProduct.active"
          dense
          hide-details
          :disabled="!isEditable"
        >
          <template v-slot:label>
              Active
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="3">
        <v-select class="mr-2" :loading="loading" v-model="workingProduct.productMapping" item-text="fiProductName"
          label="Product Mapping" ref="productMappingSelect" outlined dense hide-details return-object :items="productMappings"
          :rules="requiredRule" :disabled="!isEditable" :readonly="product && product.id !== null"/>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="3">
        <text-box-date-picker
          class="pa-0 ma-0"
          v-model="workingProduct.launchDate"
          label="Product Launch Date"
          :disabled="!isEditable"
        />
      </v-col>
    </v-row>
    <v-row class="ma-0" v-if="concatenatedProductCodes.length > 0">
      <v-col cols="12" ref="productCodes">
        Product Codes: {{concatenatedProductCodes}}
      </v-col>
    </v-row>

    <v-slide-y-transition>
      <v-container v-if="workingProduct.productMapping && workingProduct.productMapping.productType === 'KASASA_TUNES'" class="ma-0 pa-0" ref="tunesSection">
          <v-divider/>
          <v-row class="mt-2 ml-0 mb-0">
            <v-col cols="12" class="pb-0">
              <h3>Kasasa Tunes</h3>
            </v-col>
          </v-row>
          <v-row class="mt-0 ml-1">
            <v-col cols="3" >
              <v-text-field
                label="Kasasa Tunes Sign up Bonus"
                v-model="workingProduct.kasasaTunesConfiguration.signUpBonusAmount"
                prefix="$"
                type="number"
                hide-spin-buttons
                dense
                hint="ex. 10.00"
                :rules="requiredAndPositiveRule"
                name="tunesSignupBonus"
                :disabled="!isEditable"
              />
            </v-col>
        </v-row>
        <v-row class="mt-0 ml-1">
          <v-col cols="2">
            <v-text-field
              v-model="workingProduct.kasasaTunesConfiguration.signUpBonusExpirationDays"
              prefix="Valid for"
              suffix="days"
              type="number"
              dense
              hide-spin-buttons
              hint="ex. 30"
              :rules="requiredAndPositiveRule"
              :disabled="!isEditable"
              name="tunesBonusExpirationDays"/>
            </v-col>
        </v-row>
      </v-container>
    </v-slide-y-transition>

    <v-slide-y-transition>
      <v-container v-if="workingProduct.productMapping && workingProduct.productMapping.productType !== 'KASASA_SAVER' && workingProduct.productMapping.productType !== 'BUSINESS_REAL_SAVER'" class="mx-0 mb-2 pa-0" ref = "sweepSection">
        <v-divider/>
        <v-row class="mt-2 ml-0 mb-1">
          <v-col cols="12">
            <h3>Rewards Transfer (Sweep) Logic</h3>
          </v-col>
        </v-row>

        <v-slide-y-transition>
          <v-row v-if="workingProduct.linkedAccountMethodology === 'FI_HANDLES_SWEEP' || workingProduct.linkedAccountMethodology === 'FI_DOES_NOT_SWEEP'" class="ml-1 mb-1" ref="updateReminder">
            <div class="red--text">Please remember to update the Posting Configuration to reflect the change in Rewards Transfer Logic.</div>
          </v-row>
        </v-slide-y-transition>

        <v-row class="ma-0" >
          <v-radio-group dense hide-details class="mt-0" v-model="workingProduct.linkedAccountMethodology" :rules="requiredRule" :disabled="!isEditable">
            <v-radio label="Deposit Rewards directly to Linked Account" :value="'DIRECT'" ref="directDepositRadio"/>
            <v-radio label="Rewards are deposited to Primary account and transferred on Second drop day (Second Day Sweep)" :value="'SECOND_DAY_SWEEP'" ref="secondDaySweepRadio"/>
            <v-radio label="FI/Core handles sweep - Kasasa will not generate a sweep file" :value="'FI_HANDLES_SWEEP'" ref="fiHandlesSweepRadio"/>
            <v-radio label="FI does NOT sweep rewards - Kasasa will not generate a sweep file" :value="'FI_DOES_NOT_SWEEP'" ref="fiDoesNotSweepRadio"/>
          </v-radio-group>
        </v-row>
      </v-container>
    </v-slide-y-transition>

    <v-divider/>

    <v-row class="mt-2 ml-0 mb-0">
      <v-col cols="12">
        <h3>Service Fee</h3>
      </v-col>
    </v-row>

    <v-row class="ma-0">
      <v-col class="ma-0 pt-0">
        <v-checkbox id="serviceFeeCheck"
        :ripple="false"
        v-model = "workingProduct.serviceFee"
        label = "Charge Service Fee"
        ref="chargeServiceFee"
        :disabled="!isEditable"
      />
      </v-col>
    </v-row>

    <v-slide-y-transition>
      <v-row class="ma-0" v-if="workingProduct.serviceFee">
        <v-col cols="3" class="ma-0 pt-0">
          <v-text-field
            label="Fee Amount"
            v-model="workingProduct.serviceFeeAmount"
            prefix="$"
            type="number"
            hide-spin-buttons
            dense
            hint="ex. 4.00"
            :rules="requiredAndPositiveRule"
            ref="serviceFee"
            name="serviceFee"
            :disabled="!isEditable"
          />
        </v-col>
      </v-row>
    </v-slide-y-transition>

    <v-divider/>

    <v-row class="ma-0">
      <v-col v-if="workingProduct && workingProduct.id">
        <v-btn text @click="onDelete()" color="primary" :loading="deleting" ref="deleteButton" :disabled="!isEditable">Delete</v-btn>
      </v-col>
      <v-spacer v-else/>
      <v-col cols="auto" class="mr-auto">
        <v-btn
          color="primary"
          ref="resetButton"
          class="pl-16 pr-16"
          @click="onReset()"
          :loading="saving"
          :disabled="deleting || !isEditable || !isDirty"
        >Reset</v-btn>
      </v-col>

      <v-col cols="auto" class="mr-auto">
        <v-btn
          color="primary"
          ref="saveButton"
          class="pl-16 pr-16"
          @click="onSave()"
          :loading="saving"
          :disabled="!isFormValid || deleting || !isEditable || !isDirty || !isDesignDateValid.isValid"
        >Save</v-btn>
      </v-col>
    </v-row>

  </v-form>

</v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import _ from 'lodash';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass, Dialog } from '@kasasa/fbase-components/lib';
import { TextBoxDatePicker } from '@kasasa/portal-components';
import { Product, ProductResource } from '@/api/product';
import { DateTool, ValidationTool } from '@/util';
import {
  QualRewardGroup,
} from '@/api/product/levelrewards';
import { InterestReward } from '@/api/product/levelrewards/rewards';
import { LinkedAccountQualifier } from '@/api/product/levelrewards/qualifiers';
import { ProductMapping } from '@/api/productmapping';
import { ConfigVersion, ConfigVersionDateRange } from '@/api/configversion';

@Component({
  computed: mapState(['fiId', 'allConfigVersions', 'configVersion']),
  components: {
    TextBoxDatePicker,
  },
})
export default class ProductSettings extends Vue {
  fiId!: string;

  allConfigVersions!: ConfigVersion[];

  configVersion!: ConfigVersion;

  @Prop() product!: Product;

  @Prop({ default: () => [] }) versionedProducts!: Product[];

  @Prop({ default: false }) isEditable!: boolean;

  @Prop({ default: false }) isDirty!: boolean;

  @Prop({ default: () => [] }) unassignedProductMappings!: ProductMapping[];

  @Prop({ default: false }) loading!: boolean;

  workingProduct:Product = ProductResource.createEmptyProduct();

  @Inject('ProductResource')
  productResource!: ProductResource;

  configVersionDateRange: ConfigVersionDateRange | null = null;

  productMappings:ProductMapping[] = [];

  isFormValid: boolean = false;

  isDesignDateValid: {isValid: boolean, message?: string|null} = { isValid: true, message: 'default' };

  saving: boolean = false;

  deleting: boolean = false;

  concatenatedProductCodes:string = '';

  initializingForm: boolean = true;

  requiredRule:Array<any> = [(value: any) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.setupConfigDateRange();
    this.onProductChange();
    this.setupProductMappings();
  }

  @Watch('product')
  onProductChange() {
    Object.assign(this.workingProduct, this.product);
    this.onDesignStartDateChange();
    this.initializingForm = true;
  }

  @Watch('unassignedProductMappings')
  setupProductMappings() {
    if (this.product && this.product.id && this.product.productMapping) {
      this.productMappings = [this.product.productMapping];
    } else {
      this.productMappings = this.unassignedProductMappings;
    }

    if (this.productMappings.length === 1) {
      // when there's only one product mapping to select, it will be preselected
      this.workingProduct.productMapping = this.productMappings[0];
    }
  }

  @Watch('workingProduct.productMapping')
  onNewProductMapping() {
    this.concatenatedProductCodes = '';
    if (this.workingProduct.productMapping) {
      for (let i = 0; i < this.workingProduct.productMapping.coreAccountProductTypes.length; i++) {
        this.concatenatedProductCodes += this.workingProduct.productMapping.coreAccountProductTypes[i].coreProductCode;

        if (i < this.workingProduct.productMapping.coreAccountProductTypes.length - 1) {
          this.concatenatedProductCodes += ', ';
        }
      }

      if (this.workingProduct.productMapping.productType === 'KASASA_TUNES' && !this.workingProduct.kasasaTunesConfiguration) {
        this.workingProduct.kasasaTunesConfiguration = {
          signUpBonusAmount: null,
          signUpBonusExpirationDays: null,
        };
      }
    }
  }

  @Watch('workingProduct.designStartDate')
  onDesignStartDateChange() {
    this.isDesignDateValid = this.getDesignStartDateValidationResults();
  }

  onSave() {
    this.saving = true;

    if (!this.workingProduct.serviceFee) {
      this.workingProduct.serviceFeeAmount = null;
    }

    this.productResource.save(this.fiId, this.workingProduct).then((savedProduct:Product) => {
      if (this.product) {
        Object.assign(this.product, savedProduct);
      }
      Object.assign(this.workingProduct, savedProduct);
      if (this.isSaverAndHasNoLevels()) {
        this.addLevelsToSaver();
        this.onSave();
      } else {
        this.saving = false;
        this.$emit('saved', savedProduct);
        this.workingProduct = savedProduct;
        this.showSuccessMessage('Product saved successfully.');
      }
    }).catch((error:any) => {
      this.saving = false;
  	  this.showError(error);
  	});
  }

  onReset() {
    this.$emit('reset');
  }

  @Watch('workingProduct', { deep: true })
  onWorkingProductChange() {
    if (this.initializingForm) {
      this.initializingForm = false;
    } else {
      const isDirty: boolean = _.isEqual(this.product, this.workingProduct) === false;
      this.$emit('dirtyForm', isDirty);
    }
  }

  onDelete() {
    const dialog = new Dialog('Confirm Deletion', 'Are you sure you want to delete this product?');
	    dialog.setAcceptLabel('OK')
	      .setDeclineLabel('Cancel');
	    this.$store.dispatch('notices/add', dialog).then((ok) => {
	      if (ok === 'accept') {
        this.deleteProduct();
      }
    });
  }

  setupConfigDateRange() {
    this.configVersionDateRange = ConfigVersionDateRange.ofVersion(this.configVersion, this.allConfigVersions);
    this.onDesignStartDateChange();
  }

  isSaverAndHasNoLevels(): boolean {
    return (this.workingProduct.productMapping.productType === 'KASASA_SAVER'
           || this.workingProduct.productMapping.productType === 'BUSINESS_REAL_SAVER')
           && this.workingProduct.qualRewardGroups.length === 0;
  }

  isStartDateChangeable(): boolean {
    const areOtherVersionOfProduct = this.versionedProducts && this.versionedProducts.length > 0;
    const isNewProduct = !this.product || !this.product.id;

    if (isNewProduct && !areOtherVersionOfProduct) {
      return false;
    }

    if (!this.configVersionDateRange) {
      return false;
    }

    return this.product.designStartDate !== DateTool.toIsoDateString(this.configVersionDateRange.startDate);
  }

  isStartDateInUse(startDate: string): boolean {
    if (!this.versionedProducts) {
      return false;
    }

    for (let i = 0; i < this.versionedProducts.length; i++) {
      const product = this.versionedProducts[i];
      if (product.designStartDate === startDate && product.id !== this.product.id) {
        return true;
      }
    }

    return false;
  }

  isDateInCoreVersionRange(startDate: string): boolean {
    if (this.configVersionDateRange) {
      return this.configVersionDateRange.isInConfigRange(startDate);
    }
    return true;
  }

  constructStartDateRangeErrorMessage(): string {
    if (!this.configVersionDateRange) {
      return 'Design start date must be in config version date range';
    }

    const startDate = DateTool.toFriendlyFormatFromDate(this.configVersionDateRange.startDate);
    const endDate = DateTool.toFriendlyFormatFromDate(this.configVersionDateRange.endDate);

    if (!this.configVersionDateRange.endDate) {
      return `Design Start Date must be on or after ${startDate}`;
    }

    return `Design Start Date must be between ${startDate} and ${endDate} (inclusive)`;
  }

  getDesignStartDateValidationResults() {
    const startDate: string = this.workingProduct.designStartDate;
    const tuple: {isValid: boolean, message?: string} = { isValid: false };

    if (!startDate) {
      tuple.message = 'Design Start Date is required';
      return tuple;
    }

    if (this.isStartDateInUse(startDate)) {
      tuple.message = `Design Start Date ${startDate} is already in use by a product design version`;
      return tuple;
    }

    if (!this.isDateInCoreVersionRange(startDate)) {
      tuple.message = this.constructStartDateRangeErrorMessage();
      return tuple;
    }

    tuple.isValid = true;
    return tuple;
  }

  addLevelsToSaver() {
    const qualRewardLevelZero:QualRewardGroup = ProductResource.createEmptyQualRewardGroup();

    const nonQualInterestReward:InterestReward = new InterestReward();
    nonQualInterestReward.tier1 = { apr: '0.05' };

    qualRewardLevelZero.rewards.push(nonQualInterestReward);

    const qualRewardLevelOne = ProductResource.createEmptyQualRewardGroup();
    qualRewardLevelOne.level = 1;

    const interestReward:InterestReward = new InterestReward();

    interestReward.tier1 = {
      apr: '1.51',
      cap: '50000.00',
    };

    interestReward.tier2 = {
      apr: '0.49',
    };

    qualRewardLevelOne.rewards.push(interestReward);

    const linkedAccountQualifier: LinkedAccountQualifier = new LinkedAccountQualifier();
    qualRewardLevelOne.qualifiers.push(linkedAccountQualifier);

    this.workingProduct.qualRewardGroups.push(qualRewardLevelZero);
    this.workingProduct.qualRewardGroups.push(qualRewardLevelOne);
  }

  deleteProduct() {
    this.deleting = true;
    this.productResource.remove(parseInt(this.fiId, 10), this.workingProduct.id!).then(() => {
      this.$emit('deleted');
    }).catch((error:any) => {
  	  this.showError(error);
  	}).finally(() => {
	    this.deleting = false;
  	 });
  }

  showError(error: any) {
	  console.error(error);
	  if (error.response && error.response.data && error.response.data.entity) {
	    this.showErrorMessage(error.response.data.entity);
	  } else if (error.response && error.response.data && Array.isArray(error.response.data.data) && error.response.data.data.length > 0) {
      this.showErrorMessage(error.response.data.data[0].message);
    } else {
	    this.showErrorMessage('An unexpected error occurred.');
	  }
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  showSuccessMessage(error: string) {
    const al = new Alert(error, NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
</script>
<style lang="scss">
</style>
